import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { reactRouterProps } from '~/types';
import { rootRoutes } from '~/common/routerConfig';

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        rest.isLoggedIn ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: rootRoutes.login,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  ...reactRouterProps,
  isLoggedIn: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.isLoggedIn
  };
};

export default connect(mapStateToProps)(PrivateRoute);
